import { createClient } from "@supabase/supabase-js";
export const supabase = createClient(
  "https://jsyzxscinfrfcebiqmja.supabase.co",
  "sb_publishable_KtY55FFvhf5WfSZpO3nSoA_02XnFl1l"
);
